import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import SelectComponent from '../components/select/Select';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';
import HeaderComponent from '../components/table/header/headerComponent';

import { getCategoriesAction } from '../app/store/actions/categories';
import { getBrandsAction } from '../app/store/actions/brands';
import FeaturedManufactureAction from '../app/store/actions/featuredManufacturer';

class FeaturedManufacturerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryId: '',
      brandId: '',

      message: '',
      success: '',
    };
  }

  async componentDidMount() {
    await this.props.getCategories();
    await this.props.getBrands();
  }

  goBack = () => {
    history.push(ROUTES.FEATURED_MANUFACTURE);
  }

  getCategoryBody =
  categories => categories.map(category => (<option key={category.id} value={category.id}>{category.name}</option>))

  getBrandBody =
  brands => brands.map(brand => (<option key={brand.id} value={brand.id}>{brand.description}</option>))

  createManufaturer = async () => {
    const { categoryId, brandId } = this.state;
    if (!categoryId) this.setState({ success: '', message: I18n.t('selectCategory') });
    else if (!brandId) this.setState({ success: '', message: I18n.t('selectBrand') });
    else {
      try {
        await this.props.createFManufaturer(categoryId, brandId);
        this.setState({
          success: I18n.t('created'), message: '', categoryId: '', brandId: '',
        });
      } catch (err) {
        if (err.response && err.response.data.error.code === 303) {
          this.setState({ success: '', message: I18n.t('categoryAssociated') });
        } else {
          this.setState({ success: '', message: I18n.t('errorOcurred') });
        }
      }
    }
  }

  render() {
    const {
      categoryId, brandId, message, success,
    } = this.state;
    const { categories, brands } = this.props;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('spotlightManufacturerRegister')}
        />
        {brands && (
          <SelectComponent
            title={I18n.t('brand')}
            value={brandId}
            body={this.getBrandBody(brands)}
            onChange={e => this.setState({ brandId: e.target.value, success: '', message: '' })}
          />
        )}
        {categories && (
        <SelectComponent
          title={I18n.t('category')}
          value={categoryId}
          body={this.getCategoryBody(categories)}
          onChange={e => this.setState({ categoryId: e.target.value, success: '', message: '' })}
        />
        )}
        <button
          type="button"
          onClick={this.goBack}
          className="btn btn-warning margin-right-15"
        >
          <Translate value="return" />
        </button>
        <button
          type="button"
          className="btn btn-dark"
          onClick={this.createManufaturer}
        >
          <Translate value="register" />
        </button>

        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.categories.categories,
  brands: state.brands.brands,
});

const mapDispatchToProps = dispatch => ({
  getCategories: () => dispatch(getCategoriesAction()),
  getBrands: () => dispatch(getBrandsAction()),
  createFManufaturer:
  (categoryId, brandId) => dispatch(FeaturedManufactureAction.createFeaturedManufacturer(categoryId, brandId)),
  deleteFManufaturer:
  (categoryId, brandId) => dispatch(FeaturedManufactureAction.deleteFeaturedManufacturer(categoryId, brandId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedManufacturerForm);
